const SportType = {
    "CYCLING": 1,
    "ICE_SPEED_SKATING": 2,
    "FORMULA_1": 3,
    "TENNIS": 5,
    "MOTO_GP": 6,
    "FOOTBALL": 7,
    "DARTS": 8,
    "CYCLOCROSS": 9,
    "GOLF": 10,
    "SNOOKER": 11,
    "OLYMPICS": 12,
    "BASKETBALL": 15,
    "DAKAR": 16,
    "SKIING": 17,
    "RUGBY": 19,
    "BIATHLON": 20,
    "HANDBALL": 21,
    "CROSS_COUNTRY": 23,
    "AMERICAN_FOOTBALL": 27,
    "SKI_JUMPING": 33,
    "MMA": 34,
    "ICE_HOKEY": 26,
    "ENTERTAINMENT": 26
}

export default Object.freeze(SportType)